import styled from "styled-components";

export const Container = styled.div``;

export const NotificationsHistoryContainer = styled.section`
    margin-top: 50px;
`;
